import { Agpm, AgpmHistoryDetailsMinimal } from '@/types';
import { Component, inject, OnInit } from '@angular/core';
import { AgpmService } from '../agpm.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableRowActions, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { getAgpmVersionHistoryDataTableStructure } from './utils/agpm-version-history-data-table-object';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { AgpmRepository } from '@/store/agpm-state/agpm-state.repository';

@Component({
  selector: 'sm-agpm-version-history',
  imports: [TranslateModule, PageHeaderComponent, DataTableBuilderComponent],
  templateUrl: './version-history.component.html',
  styleUrl: './version-history.component.scss',
})
export class AgpmVersionHistoryComponent implements OnInit {
  agpmRepository = inject(AgpmRepository);
  agpmService = inject(AgpmService);
  translate = inject(TranslateService);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);

  breadcrumb = [
    {
      label: 'agpm.breadcrumb.agpm',
      routerLink: ['/agpm-current-notice'],
    },
    {
      label: 'agpm.breadcrumb.agpmHistory',
      routerLink: ['agpm-version-history'],
    },
  ];

  agpmId = this.activatedRoute.snapshot.params['id'] as number;
  rowActions: DataTableRowActions = {
    defaultActions: {
      inspect: {
        label: 'agpm.actions.inspect',
      },
    },
    inspectAction: (row: Agpm) => {
      this.router.navigate([`agpm-inspect-notice`, row.id, row.version]);
    },
  };

  data: AgpmHistoryDetailsMinimal[] = [];
  loading = false;
  dataTableObject: DynamicDataTable = getAgpmVersionHistoryDataTableStructure({
    store: this.agpmRepository,
    rowActions: this.rowActions,
  });

  ngOnInit(): void {
    this.agpmId = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.agpmService.getAgpmHistoryDetailsMinimal(this.agpmId).subscribe({
      next: data => {
        this.data = data.content;
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: err.error.message || this.translate.instant('agpm.message.error.loading'),
        });
      },
    });
  }
}
